import * as ko from 'knockout'
import { IObservableFinisher } from '@classic/Betting-v2/Model/Observables/IObservableFinisher'
import { Disposable } from '@classic/AppUtils/Framework/Disposable/Disposable'
import Guard from '@classic/AppUtils/Framework/Guard'
import { getOrdinalSuffix } from '@mobi/utils/number/ordinal'

export class FinisherPlaceViewModel extends Disposable {
  public finisher?: IObservableFinisher
  public ordinal?: ko.PureComputed<string>

  constructor(params: { finisher: IObservableFinisher }) {
    super()

    Guard.notNull(params.finisher)

    this.finisher = params.finisher
    this.ordinal = ko.pureComputed<string>(() => {
      const placing = (this.finisher as IObservableFinisher).placing()
      return getOrdinalSuffix(placing, true)
    })
  }
}
